import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EventCard } from "@/components/EventCard";
import { Seo } from "@/components/Seo";

export default function EventsBoard() {
  const { user } = useAuth();
  const [city, setCity] = useState("");
  const [list, setList] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => api.get("/events", { params: { city } }).then((r) => setList(r.data)), 250);
    return () => clearTimeout(t);
  }, [city]);

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 pt-16" data-testid="events-board-page">
      <Seo title="Eventi e lavoro per hostess, modelle e wingwoman | YourHostess" description="Scopri gli eventi aperti in Italia che cercano hostess, modelle e wingwoman: fiere, congressi, lanci di prodotto e serate. Candidati in pochi secondi." />
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="eyebrow">Opportunità</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">Eventi aperti</h1>
          <p className="text-neutral-400 mt-4 max-w-lg">{user?.role === "hostess" ? "Candidati agli eventi: il cliente riceverà subito la tua disponibilità." : "Gli eventi pubblicati dai clienti in cerca di hostess e modelle."}</p>
        </div>
        {user?.role === "client" && <Link to="/eventi/nuovo" className="btn-gold" data-testid="events-create-button">Pubblica evento</Link>}
      </div>
      <div className="mt-12 max-w-md flex items-center gap-3 border-b border-white/15 focus-within:border-[#D4AF37] transition-colors">
        <MapPin className="w-4 h-4 text-[#D4AF37]" />
        <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Filtra per città" className="bg-transparent flex-1 py-3 focus:outline-none placeholder:text-neutral-600" data-testid="events-city-filter" />
      </div>
      {!user && <p className="mt-6 text-sm text-neutral-500">Accedi per vedere i dettagli e candidarti. <Link to="/accedi" className="text-[#D4AF37]" data-testid="events-login-link">Accedi</Link></p>}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10" data-testid="events-grid">
        {(list || []).map((e, i) => <EventCard key={e.id} e={e} index={i} to={user ? undefined : "/accedi"} />)}
      </div>
      {list && list.length === 0 && <p className="font-serif text-3xl text-neutral-500 py-20" data-testid="events-empty">Nessun evento aperto al momento</p>}
    </main>
  );
}
